import {
  ExternalOutlined,
  InboundFilled,
  OutboundFilled,
  VoicemailOutlined,
} from "@aircall/icons";
import { Flex, Typography } from "@aircall/tractor";
import { useTranslation } from "react-i18next";

import { SectionHeader } from "../SectionHeader";
import { SectionLayout } from "../SectionLayout";

import { PickCallTypeProps } from "./SectionCallType.decl";

import { buildCallTimelineLink } from "@/components/SectionTiming";
import { useCall } from "@/hooks/useCall/useCall";
import { Icon, Link } from "@aircall/tractor";

function PickCallType({ value }: PickCallTypeProps) {
  const { t } = useTranslation();

  switch (value) {
    case "inbound":
      return (
        <Flex alignItems="center" gap="xxs">
          <InboundFilled color="icon-interactive-primary" />
          <Typography variant="bodyMediumS">{t("inbound")}</Typography>
        </Flex>
      );

    case "outbound":
      return (
        <Flex alignItems="center" gap="xxs">
          <OutboundFilled color="icon-interactive-informative" />
          <Typography variant="bodyMediumS">{t("outbound")}</Typography>
        </Flex>
      );

    case "voicemail":
      return (
        <Flex alignItems="center" gap="xxs">
          <VoicemailOutlined color="icon-interactive-warning" />
          <Typography variant="bodyMediumS">{t("voicemail")}</Typography>
        </Flex>
      );

    default:
      break;
  }
}

export function SectionCallType() {
  const { t } = useTranslation();
  const { call } = useCall();

  if (!call?.type) {
    return null;
  }

  return (
    <SectionLayout data-test="call-type-section">
      <SectionHeader>{t("call_context.call_type")}</SectionHeader>
      <PickCallType value={call.type} />
      {call.direction === "outbound" && call.automaticCallbackCallId && (
        <Flex alignItems="center" gap="xxs">
          <Typography variant="bodyMediumS" color="text-secondary">
            {t("call_context.callback_from")}
          </Typography>
          <Link
            data-test="open-call-timeline-anchor"
            as="a"
            target="_blank"
            href={buildCallTimelineLink(call.automaticCallbackCallId)}
          >
            {t("call_context.callback_request")}
            <Icon component={ExternalOutlined} size={18} pl="2px" />
          </Link>
        </Flex>
      )}
    </SectionLayout>
  );
}
